import { Component, OnInit, AfterViewInit,Input, SimpleChanges } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../../../../core/auth/auth.service';
import { UserService } from '../../../../core/user.service';
import * as Chart from "chart.js";
import { bloomAdd } from '@angular/core/src/render3/di';
@Component({
  selector: 'app-cqmns-log-usersummary',
  templateUrl: './cqmns-log-usersummary.component.html',
  styleUrls: ['./cqmns-log-usersummary.component.css']
})
export class CqmnsLogUsersummaryComponent implements OnInit {

  @Input() logUpload: any;
  logusercount :any;
  loguserhitcount:any;
  projects: any;
  projectId: any;
  gadatausers: any;
  hostUrl;
  userdate: any;
  userscount: any;
  ctxlogusersum: any;
  canvaslogusersum: any;
  myChartlogusersum: any;
  ctxgabouncesum: any;
  canvasgabouncesum: any;
  myChartgasessionsum: any;
  ctxgasessionsum: any;
  canvasgasessionsum: any;
  myChartgabouncesum: any;
  gauserssum: any = [];
  bouncesum: any = [];
  sessionsum: any = [];
  date: any;
  myChartgausers: any;
  myChartgausergaUser: any;
  selectedduration: any;
  valuesum = 'Users';
  duration: any;
  gadata: any;
  User: any;
  SessionDuration: any;
  BounceRate: any;
  val1:any;
  val2: any;
  value1: any;
  value2: any;
  value3: any;
  
  ctxgauser: any;
  canvasgauser: any;
  myChartgauser: any;
  ctxgauser1: any;
  canvasgauser1: any;
  myChartgauser1: any;
  gausers: any = [];
  classificationsgausers = [];
  noOfclassificationsgausers = [];
  labels: any = [];
  data: any = [];
  gausers2: any;
  gausers1:any;
  myChartgauser2: any;
  canvasgauser2: any;
  ctxgauser2: any;
  selectedIndex: any;
  viewIdApi: any;
  hideDash: boolean;
  uniqueVisitorsCount: any =[];
  osCountFromLog: any;
  browserDataFromLog: any;
  pageViewsFromLog: any;
  totalUser: any;
  HitsCount: any  =[];
  totalHits:any;
  val:any;
  showValue:any;
  userId:any;
  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private userService: UserService, private authService: AuthService, 
  ) {}

  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
    this.hideDash = false;
    this.hostUrl = this.userService.getUrl();
    this.userId = localStorage.getItem("userid");
    this.projectId = localStorage.getItem("projectId");
    this.getData();

  }
    ngOnChanges(changes:SimpleChanges){
    console.log('in ngOnChange',this.logUpload)
    this.showValue = changes.logUpload.currentValue;
    console.log('in changes',changes)
    console.log('in show value',this.showValue)
    if(this.showValue === "false"){
      this.getData();  
    }
  } 
onchange(val) {
  this.val = val;
}
getData(){
  this.http
  .get(
    encodeURI(
      this.hostUrl +
        "/api/issue/dayWiseCountHits/" +
        this.projectId 
    )
  )
  .subscribe(data => {
  
  this.loguserhitcount = data;
  for (let i = 1; i < this.loguserhitcount.length; i++) {
    this.HitsCount.push(this.loguserhitcount[i]);
  }
  this.totalHits  = this.loguserhitcount[0].totaluser;
  this.updateBounceChart();
  this.updateChartgaBouncesum(this.myChartgabouncesum);
});
  this.http
  .get(
    encodeURI(
      this.hostUrl +
        "/api/issue/uniqueVisitorsCount/" +
        this.projectId 
    )
  )
  .subscribe(data => {
  
  this.logusercount = data;
  for (let i = 1; i < this.logusercount.length; i++) {
    this.uniqueVisitorsCount.push(this.logusercount[i]);
  }
  this.totalUser  = this.logusercount[0].totaluser;
  this.updateUser();
  this.updateChartgaUsersum(this.myChartlogusersum);
});
}
  updateUser() {

    Chart.defaults.global.defaultFontColor = "#000";
    this.canvaslogusersum = document.getElementById("myChartlogusersum");
    this.ctxlogusersum = this.canvaslogusersum.getContext("2d");
    this.myChartlogusersum = new Chart(this.ctxlogusersum, {
      type: "line",
      data: {
        labels: [],
        datasets: [
       
          {
            data: [],
            label: "Users Count",
            borderColor: "#67b2c7",
            backgroundColor: "#67b2c7",
            borderWidth: 2,
             fill: false,
             lineTension: 0,
        borderJoinStyle: 'miter',
          }
        ]
      },
      options: {
        title: {
          display: true,
          text: 'Users  ',
          fontColor: "#5f7388",
          fontSize: 15
      },
      tooltips: {
        mode: 'index',
        intersect: false,
      },
      hover: {
        mode: 'nearest',
        intersect: true
      },
        responsive: true, // for chart resize after update issue
        maintainAspectRatio: false,
        legend: {
          display: true
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display:false
             },
             scaleLabel: {
              display: true,
              labelString: 'Day',
              fontFamily: 'verdana',
              fontSize: 12
            },
              ticks: {
                autoSkip: true,
                maxTicksLimit: 6,
                stepSize: 0.2
              },
               autoSkip: false,
              display: true,
              type: "time",
              time: {
                parser: "YYYYMMDD",
                unit: "day",
                unitStepSize: 1,
                tooltipFormat: "MMM DD YYYY",
                displayFormats: {
                  day: " DD MMM YYYY"
                }
              }
            }
          ],
          yAxes: [
            { 
              gridLines: {
              display:true
           },
           scaleLabel: {
            display: true,
            labelString: 'Users Count ',
            fontFamily: 'verdana',
            fontSize: 12,
           
          },
              ticks: {
                beginAtZero: true,
                userCallback: function(label, index, labels) {
                     // when the floored value is the same as the value we have a whole number
                     if (Math.floor(label) === label) {
                         return label;
                     }

                 },
                
              }
            }
          ]
        }
      }
    });
  }
    updateBounceChart() {
    this.canvasgabouncesum = document.getElementById("myChartgabouncesum");
    this.ctxgabouncesum = this.canvasgabouncesum.getContext("2d");
    this.myChartgabouncesum = new Chart(this.ctxgabouncesum, {
      type: "line",
      data: {
        labels: [],
        datasets: [
          {
            data: [],
            label: " Hits Count",
            borderColor: "#67b2c7",
            backgroundColor: "#67b2c7",
            borderWidth: 2,
             fill: false,
             lineTension: 0,
        borderJoinStyle: 'miter',
          },
          {
            data: [],
            label: "Users Count",
            borderColor: "#DB7093",
            backgroundColor: "#DB7093",
            borderWidth: 2,
             fill: false,
             lineTension: 0,
        borderJoinStyle: 'miter',
          }
        ]
      },
      options: {
        title: {
          display: true,
          text: 'Page Hits  ',
          fontColor: "#5f7388",
          fontSize: 15
      },
      tooltips: {
        mode: 'index',
        intersect: false,
      },
      hover: {
        mode: 'nearest',
        intersect: true
      },
        responsive: true, // for chart resize after update issue
        maintainAspectRatio: false,
        legend: {
          display: true
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display:false
             },
             scaleLabel: {
              display: true,
              labelString: 'Day',
              fontFamily: 'verdana',
              fontSize: 12
            },
              ticks: {
                autoSkip: true,
                maxTicksLimit: 6,
                stepSize: 0.2
              },
              // autoSkip: false,
              display: true,
              type: "time",
              time: {
                parser: "YYYYMMDD",
                unit: "day",
                unitStepSize: 1,
                tooltipFormat: "MMM DD YYYY",
                displayFormats: {
                  day: "DD MMM YYYY"
                }
              }
            }
          ],
          yAxes: [
            { 
              gridLines: {
              display:true
           },
           scaleLabel: {
            display: true,
            labelString: 'Page Hits ',
            fontFamily: 'verdana',
            fontSize: 12,
           
          },
              ticks: {
                beginAtZero: true,
                userCallback: function(label, index, labels) {
                  // when the floored value is the same as the value we have a whole number
                  if (Math.floor(label) === label) {
                      return label;
                  }

              },
              }
            }
          ]
        }
      }
    });
  }
  // updateSessionChart() {
  //   this.canvasgasessionsum = document.getElementById("myChartgasessionsum");
  //   this.ctxgasessionsum = this.canvasgasessionsum.getContext("2d");
  //   this.myChartgasessionsum = new Chart(this.ctxgasessionsum, {
  //     type: "line",
  //     data: {
  //       labels: [],
  //       datasets: [
  //         {
  //           data: [],
  //           label: "Users",
  //           borderColor: "#67b2c7",
  //           borderWidth: 2,
  //            fill: false,
  //            lineTension: 0,
  //       borderJoinStyle: 'miter',
  //         }
  //       ]
  //     },
  //     options: {
  //       title: {
  //         display: true,
  //         text: 'Session Duration',
  //         fontColor: "#5f7388",
  //         fontSize: 15
  //     },
  //       responsive: true, // for chart resize after update issue
  //       maintainAspectRatio: false,
  //       legend: {
  //         display: false
  //       },
  //       scales: {
  //         xAxes: [
  //           {
  //             gridLines: {
  //               display:false
  //            },
  //            scaleLabel: {
  //             display: true,
  //             labelString: 'Month',
  //             fontFamily: 'verdana',
  //             fontSize: 12
  //           },
  //             ticks: {
  //               autoSkip: true,
  //               maxTicksLimit: 6,
  //               stepSize: 0.2
  //             },
  //             // autoSkip: false,
  //             display: true,
  //             type: "time",
  //             time: {
  //               parser: "YYYYMMDD",
  //               unit: "day",
  //               unitStepSize: 1,
  //               tooltipFormat: "MMM DD YYYY",
  //               displayFormats: {
  //                 day: "MMM DD"
  //               }
  //             }
  //           }
  //         ],
  //         yAxes: [
  //           {
  //             gridLines: {
  //               display:true
  //            },
  //            scaleLabel: {
  //             display: true,
  //             labelString: 'Session Duration',
  //             fontFamily: 'verdana',
  //             fontSize: 12,
             
  //           },
  //             ticks: {
  //               beginAtZero: true
  //             }
  //           }
  //         ]
  //       }
  //     }
  //   });
  // }
  changechart(val){
    this.valuesum = val;
    }
  updateChartgaUsersum(myTrendsum) {
 
    for (let i = 0; i < this.uniqueVisitorsCount.length; i++) {
      console.log(this.uniqueVisitorsCount.length)
     if(this.uniqueVisitorsCount.length >1){
      myTrendsum.data.labels.push(this.uniqueVisitorsCount[i].Date);
      myTrendsum.data.datasets[0].data.push(this.uniqueVisitorsCount[i].user);
     }
     else if(this.uniqueVisitorsCount.length = 1){
      myTrendsum.data.labels.push('20200618',this.uniqueVisitorsCount[i].Date,'20200620');
      myTrendsum.data.datasets[0].data.push(null,this.uniqueVisitorsCount[i].user,null);     }
     
    }
    myTrendsum.update();
  }
  updateChartgaBouncesum(myTrendsum) {
    for (let i = 0; i < this.HitsCount.length; i++) {
      if(this.HitsCount.length>1){
      myTrendsum.data.labels.push(this.HitsCount[i].Date);
      myTrendsum.data.datasets[0].data.push(this.HitsCount[i].hits);
      myTrendsum.data.datasets[1].data.push(this.HitsCount[i].users);
    } else if(this.HitsCount.length=1)
    {
      myTrendsum.data.labels.push('20200618',this.HitsCount[i].Date,'20200620');
      myTrendsum.data.datasets[0].data.push(null,this.HitsCount[i].hits,null);
      myTrendsum.data.datasets[1].data.push(null,this.HitsCount[i].users,null);
    }
  }   
 myTrendsum.update();
  }
  // updateChartgaSessionsum(myTrendsum) {
  //   for (let i = 0; i < this.sessionsum.length; i++) {
  //     myTrendsum.data.labels.push(this.sessionsum[i].date);
  //     myTrendsum.data.datasets[0].data.push(this.sessionsum[i].sessionDuration);
  //   }
  //   myTrendsum.update();
  // }

}






// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqmns-log-analytics/cqmns-log-usersummary/cqmns-log-usersummary.component.ts